import { parse } from "jsonlint-mod";
export function getJSONValidity(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  try {
    parse(input);
    return "JSON is valid!";
  } catch (e) {
    console.log("e", e);
    throw e;
  }
}